import { createSlice } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';

const initialState = {
  repayMentData: {},
  repayMentDataDisb: {},
  activeLoanData: {},
  productWiseDataItem: {},
  loanDetails: {},
  dueDateMessage: '',
  selectedIndex: 0,
  repayParams: {},
};

export const repaymentSlice = createSlice({
  name: 'repayment',
  initialState,
  reducers: {
    upodateRepaymentData: (state, action) => {
      state.repayMentData = action.payload;
    },
    updateRepaymentDataDisb: (state, action) => {
      state.repayMentDataDisb = action.payload;
    },
    updateProductWiseDataItem: (state, action) => {
      state.productWiseDataItem = action.payload;
    },
    updateLoanDetails: (state, action) => {
      state.loanDetails = action.payload;
    },
    updateSelectedIndex: (state, action) => {
      state.selectedIndex = action.payload;
    },
    updateRepayParams: (state, action) => {
      state.repayParams = action.payload;
    },
  },
});

export function useRepaymentStore() {
  const repayMentData = useSelector((state) => state.repayment.repayMentData);
  const repayMentDataDisb = useSelector(
    (state) => state.repayment.repayMentDataDisb
  );
  const activeLoanData = useSelector((state) => state.repayment.activeLoanData);
  const productWiseDataItem = useSelector(
    (state) => state.repayment.productWiseDataItem
  );
  const loanDetails = useSelector((state) => state.repayment.loanDetails);
  const selectedIndex = useSelector((state) => state.repayment.selectedIndex);
  const repayParams = useSelector((state) => state.repayment.repayParams);

  const dispatch = useDispatch();
  return {
    repayMentData,
    activeLoanData,
    repayMentDataDisb,
    productWiseDataItem,
    loanDetails,
    selectedIndex,
    repayParams,
    updateRepayParams: (payload) => dispatch(updateRepayParams(payload)),
    upodateRepaymentData: (payload) => dispatch(upodateRepaymentData(payload)),
    updateRepaymentDataDisb: (payload) =>
      dispatch(updateRepaymentDataDisb(payload)),
    updateProductWiseDataItem: (payload) =>
      dispatch(updateProductWiseDataItem(payload)),
    updateSelectedIndex: (payload) => dispatch(updateSelectedIndex(payload)),
    updateLoanDetails: (payload) => dispatch(updateLoanDetails(payload)),
  };
}

export const {
  upodateRepaymentData,
  updateProductWiseDataItem,
  updateLoanDetails,
  updateSelectedIndex,
  updateRepayParams,
  updateRepaymentDataDisb,
} = repaymentSlice.actions;

export default repaymentSlice.reducer;
